import {useMutation} from "@apollo/client";

import {
  GQL_EDIT_SLA_REPORT,
  GQL_SLA_REPORT_VIEW,
  GQL_SLA_REPORTS,
  GQL_UPDATE_SLA_REPORT,
  SLAReport,
} from "@/lib/queries/reports.ts";
import {ServiceGroup, ServiceTag} from "@/lib/types/checks.ts";
import {ResponseStatus} from "@/lib/types/common.ts";
import {SLAReportForm} from "@/pages/reports/sla/SLAReportForm.tsx";
import {SLAReportFormValues} from "@/pages/reports/sla/SLAReportForm.types.ts";
import {groupInEditChecksField, groupInEditNameField} from "@/pages/reports/sla/SLAReportForm.utils.tsx";

interface SLAReportUpdateModalProps {
  title: string;
  onClose: () => void;
  monitoringServiceTypes: ServiceGroup[];
  tags: ServiceTag[];
  slaReport?: SLAReport;
  slaReportGlobalLogoUrl: string;
}

export const SLAReportUpdateDrawer = ({
  title,
  onClose,
  tags,
  monitoringServiceTypes,
  slaReport,
  slaReportGlobalLogoUrl,
}: SLAReportUpdateModalProps) => {
  const formID = "sla-update-form";
  const [updateSLAReport, {data}] = useMutation(GQL_UPDATE_SLA_REPORT, {
    refetchQueries: [GQL_SLA_REPORTS, GQL_SLA_REPORT_VIEW, GQL_EDIT_SLA_REPORT],
    context: {
      noToast: true,
    },
  });
  const onConfirm = async (data: SLAReportFormValues) => {
    // eslint-disable-next-line no-unused-vars
    const {[groupInEditNameField]: _name, [groupInEditChecksField]: _checks, logo, ...submitData} = data;
    const result = await updateSLAReport({
      variables: {
        data: {
          ...submitData,
          logo: logo instanceof FileList && logo.length > 0 ? logo[0] : logo === null ? null : undefined,
        },
      },
    });
    if (result.data?.response.status === ResponseStatus.SUCCESS) {
      onClose();
    }
  };

  return (
    <SLAReportForm
      title={title}
      formId={formID}
      onSubmit={onConfirm}
      serverErrors={data?.response?.status === ResponseStatus.ERROR ? data.response.message : undefined}
      onCancel={onClose}
      slaReport={slaReport}
      slaReportGlobalLogoUrl={slaReportGlobalLogoUrl}
      tags={tags}
      monitoringServiceTypes={monitoringServiceTypes}
    />
  );
};
